import React, { useContext, useState } from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import styled from 'styled-components'
import { borderRadius, colors, spacing } from '../../../styles/styles'

import { environment } from '../../../environments'
import { useVideoCalls } from '../../../contexts/VideoCallsProvider'
import { authenticatedFetch } from '../../../lib/service'
import { MessageLoader } from '../../shared/Loading'
import {
  VideoCall_AcceptCall,
  VideoCall_Calling,
  VideoCall_CurrentCall,
  VideoCall_DeclineCall,
  VideoCall_IsCalling,
} from '../../../translations/messages'
import { useIntl } from 'react-intl'

//Not used because of Whereby expiration
const VideoCallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`

const CallHeader = styled.div`
  display: flex;
  padding: ${spacing.lg};
  align-items: center;
  justify-content: center;

  h1 {
    margin: 0;
  }
`

const IFrame = styled.iframe`
  flex: 3;
  border: none;
`

const ButtonGroup = styled.div`
  display: flex;
  padding: ${spacing.lg};
  align-items: center;
  justify-content: center;
`

const Button = styled.button`
  width: 300px;
  height: 48px;
  border: none;
  font-size: inherit;
  border-radius: ${borderRadius};
`

const AcceptButton = styled(Button)`
  margin-left: ${spacing.xl};
  color: white;
  background-color: ${colors.jodaDark};
`

const DeclineButton = styled(Button)`
  color: white;
  background-color: ${colors.error};
`

export const VideoCallPage = () => {
  const intl = useIntl()
  const { authUser } = useContext(AuthContext)
  const {
    videoCall,
    onVideoCallDeclined,
    onVideoCallAccepted,
  } = useVideoCalls()
  const [status, setStatus] = useState<'idle' | 'pending' | 'failure'>('idle')

  const isVideoCallRecipient = videoCall.recipient_id === authUser?.id
  const displayName = isVideoCallRecipient
    ? videoCall.recipient_name
    : videoCall.sender_name

  const roomUrl = `${videoCall.room_url}?iframeSource=jodacare&embed&screenshare=off&chat=offleaveButton=off&displayName=${displayName}&floatSelf`

  const caller = isVideoCallRecipient
    ? videoCall.sender_name
    : videoCall.recipient_name

  const acceptCall = () => {
    setStatus('pending')

    authenticatedFetch(
      `${environment.API_URL}/video-calls/${videoCall.id}/accept`,
      {
        method: 'PATCH',
      }
    )
      .then((call) => {
        setStatus('idle')
        onVideoCallAccepted(call)
      })
      .catch(() => setStatus('failure'))
  }

  const declineCall = () => {
    authenticatedFetch(`${environment.API_URL}/video-calls/${videoCall.id}`, {
      method: 'DELETE',
    })
      .then((response) => {
        setStatus('idle')
        onVideoCallDeclined()
      })
      .catch(() => setStatus('failure'))
  }

  const callHasStarted = videoCall.accepted || !isVideoCallRecipient

  return (
    <VideoCallWrapper>
      <CallHeader>
        <h1>
          {videoCall.accepted
            ? intl.formatMessage(VideoCall_CurrentCall, { name: caller })
            : isVideoCallRecipient
            ? intl.formatMessage(VideoCall_IsCalling, { name: caller })
            : intl.formatMessage(VideoCall_Calling, { name: caller })}
        </h1>
      </CallHeader>

      {callHasStarted ? (
        <IFrame src={roomUrl} allow="camera;microphone;fullscreen;speaker" />
      ) : (
        <MessageLoader />
      )}

      {!videoCall.accepted && (
        <ButtonGroup>
          <DeclineButton disabled={status === 'pending'} onClick={declineCall}>
            {intl.formatMessage(VideoCall_DeclineCall)}
          </DeclineButton>

          {isVideoCallRecipient && (
            <AcceptButton disabled={status === 'pending'} onClick={acceptCall}>
              {intl.formatMessage(VideoCall_AcceptCall)}
            </AcceptButton>
          )}
        </ButtonGroup>
      )}

      {videoCall.accepted && (
        <ButtonGroup>
          <DeclineButton disabled={status === 'pending'} onClick={declineCall}>
            {intl.formatMessage(VideoCall_DeclineCall)}
          </DeclineButton>
        </ButtonGroup>
      )}
    </VideoCallWrapper>
  )
}
